import { render, staticRenderFns } from "./ProfilePowerBiViews.vue?vue&type=template&id=029be9b2"
import script from "./ProfilePowerBiViews.vue?vue&type=script&lang=js"
export * from "./ProfilePowerBiViews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports